import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

export default function initFoodSlider() {
    // Food slider based on swiper
    const swiper = new Swiper('.food-swiper', {
        slidesPerView: 1,
        loop: true,
        pagination: {
            el: '.swiper-pagination',
        },
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        slideClass: 'cmeleon-block-content',
        loopFillGroupWithBlank: false,
    });
}
